import React, { useEffect, useState } from "react";

import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import ListItemText from "@mui/material/ListItemText";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import Holidays from "date-holidays";
import moment from "moment";

export default function Stage({
  mo,
  stageDescription,
  setStageDescription,
  stageStartDate,
  setStageStartDate,
  stageEndDate,
  setStageEndDate,
  stageDuration,
  setStageDuration,
  ressource1UserId,
  setRessource1UserId,
  ressource2UserId,
  setRessource2UserId,
  ressource3UserId,
  setRessource3UserId,
  ressource4UserId,
  setRessource4UserId,
  availableOrders,
  selectedOrderId,
  setSelectedOrderId,
  availableDevices,
  setAvailableDevices,
  selectedDeviceId,
  setSelectedDeviceId,
  global,
  edit,
}) {
  const hd = new Holidays("FR");

  function addBusinessDays(startDate, numberOfDays) {
    let date = moment(startDate);
    while (numberOfDays > 0) {
      date = date.add(1, "days");
      // Decrease only on weekdays and non-holidays
      if (date.isoWeekday() <= 5 && !hd.isHoliday(date.toDate())) {
        numberOfDays--;
      }
    }
    return date;
  }

  useEffect(() => {
    if (stageStartDate && stageDuration) {
      const endDate = addBusinessDays(stageStartDate.substring(0, 10), stageDuration - 1);
      setStageEndDate(endDate.format("YYYY-MM-DD"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stageStartDate, stageDuration]);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item container xs={12} spacing={2}>
          {global && !edit && (
            <Grid item container xs={12} spacing={2}>
              <Grid item xs={6} display="flex" alignItems="center">
                <Autocomplete
                  sx={{ width: "100%" }}
                  options={availableOrders && availableOrders}
                  value={selectedOrderId}
                  onChange={(event, newSelectedOrderId) => {
                    if (newSelectedOrderId === null) {
                      setSelectedOrderId("");
                      setSelectedDeviceId("");
                      setAvailableDevices([]);
                    } else {
                      setSelectedOrderId(newSelectedOrderId);
                      setSelectedDeviceId("");
                    }
                  }}
                  renderOption={(props, item) => (
                    <li {...props} key={item.key}>
                      {item.label}
                    </li>
                  )}
                  renderInput={(params) => (
                    <MDInput {...params} label="Affaire concernée" variant="standard" />
                  )}
                />
              </Grid>
              <Grid item xs={6} display="flex" alignItems="center">
                <Autocomplete
                  sx={{ width: "100%" }}
                  options={availableDevices && availableDevices}
                  value={selectedDeviceId}
                  onChange={(event, newSelectedDeviceId) => {
                    if (newSelectedDeviceId === null) {
                      setSelectedDeviceId(null);
                    } else {
                      setSelectedDeviceId(newSelectedDeviceId && newSelectedDeviceId);
                    }
                  }}
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      disabled={!selectedOrderId && availableDevices.length === 0}
                      label="Appareil concerné"
                      variant="standard"
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <FormField
              inputProps={{ maxLength: 255 }}
              value={stageDescription}
              onChange={(event) => setStageDescription(event.target.value)}
              required
              type="text"
              minRows={global && !edit ? 1 : 2}
              multiline
              variant="outlined"
              label="Description de la phase"
              error={!stageDescription}
              helperText={!stageDescription ? "La description est obligatoire" : ""}
            />
          </Grid>
        </Grid>
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={4} display="block" alignItems="center">
            <Stack component="form" noValidate>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                <DatePicker
                  slotProps={{ field: { clearable: true } }}
                  displayWeekNumber
                  label="Date de début"
                  value={stageStartDate && new Date(stageStartDate)}
                  onChange={(newValue) => {
                    if (newValue === null) {
                      setStageStartDate(null);
                    } else setStageStartDate(moment(newValue).format("YYYY-MM-DD"));
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  format="dd/MM/yyyy"
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
          <Grid item xs={4} display="block" alignItems="center">
            <Tooltip
              title={
                !stageDuration || !stageStartDate
                  ? "Veuillez d'abord saisir le nombre de jours ouvrés"
                  : ""
              }
              placement="top"
            >
              <Stack component="form" noValidate>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                  <DatePicker
                    slotProps={{ field: { clearable: true } }}
                    displayWeekNumber
                    disabled={!stageDuration || !stageStartDate} // Disable if no duration
                    label="Date de fin"
                    value={stageEndDate && new Date(stageEndDate)}
                    onChange={(newValue) => {
                      if (newValue === null) {
                        setStageEndDate(null);
                      } else setStageEndDate(moment(newValue).format("YYYY-MM-DD"));
                    }}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    format="dd/MM/yyyy"
                  />
                </LocalizationProvider>
              </Stack>
            </Tooltip>
          </Grid>
          <Grid item xs={4}>
            <FormField
              value={stageDuration}
              onChange={(event) => setStageDuration(event.target.value.slice(0, 3))}
              variant="standard"
              type="number"
              label="Nombre de jour ouvrés"
              inputProps={{ maxLength: 3 }}
            />
          </Grid>
        </Grid>
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={6} display="flex" alignItems="center">
            <Autocomplete
              sx={{ width: "100%" }}
              options={mo && mo}
              value={ressource1UserId}
              onChange={(event, newRessource1UserId) => {
                setRessource1UserId(newRessource1UserId);
                if (newRessource1UserId === null) {
                  setRessource2UserId(null);
                  setRessource3UserId(null);
                  setRessource4UserId(null);
                }
              }}
              renderInput={(params) => (
                <MDInput
                  {...params}
                  label="Ressource 1 : Responsable chantier"
                  sx={{ "label.MuiFormLabel-root": { fontWeight: "bold", fontSize: "1.05rem" } }}
                  variant="standard"
                />
              )}
            />
          </Grid>
          {ressource1UserId && (
            <Grid item xs={6} display="flex" alignItems="center">
              <Autocomplete
                sx={{ width: "100%" }}
                options={mo && mo}
                value={ressource2UserId}
                onChange={(event, newRessource2UserId) => {
                  setRessource2UserId(newRessource2UserId);
                  if (newRessource2UserId === null) {
                    setRessource3UserId(null);
                    setRessource4UserId(null);
                  }
                }}
                renderInput={(params) => (
                  <MDInput {...params} label="Ressource 2" variant="standard" />
                )}
              />
            </Grid>
          )}
          {ressource2UserId && (
            <Grid item xs={6} display="flex" alignItems="center">
              <Autocomplete
                sx={{ width: "100%" }}
                options={mo && mo}
                value={ressource3UserId}
                onChange={(event, newRessource3UserId) => {
                  setRessource3UserId(newRessource3UserId);
                  if (newRessource3UserId === null) {
                    setRessource4UserId(null);
                  }
                }}
                renderInput={(params) => (
                  <MDInput {...params} label="Ressource 3" variant="standard" />
                )}
              />
            </Grid>
          )}
          {ressource3UserId && (
            <Grid item xs={6} display="flex" alignItems="center">
              <Autocomplete
                sx={{ width: "100%" }}
                options={mo && mo}
                value={ressource4UserId}
                onChange={(event, newRessource4UserId) => {
                  setRessource4UserId(newRessource4UserId);
                }}
                renderInput={(params) => (
                  <MDInput {...params} label="Ressource 4" variant="standard" />
                )}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}
